import Vue from 'vue';
import * as html from './root.html';

import('../shared/components/design-system/gp-button');

export let PageNotFound = new Vue({
	render: html.render,
	staticRenderFns: html.staticRenderFns,

	components: {
		'page-404': () => import('./ui/404')
	},

	data: function ()
	{
		return {
			config: <any>null
		};
	},

	created: function ()
	{
		console.log('ManageVueRoot created');
	}
});